import React, { useState, useEffect } from "react";
import {
  ShowController,
  Show,
  SimpleShowLayout,
  ArrayField,
  TextField,
  ReferenceField,
  Labeled,
  Datagrid,
} from "react-admin";
import { Chip, Button, Typography } from "@material-ui/core";
import { parse } from "query-string";
import CustomShowActions from "../../components/CustomShowActions";
import WebhookEventsList from "../../components/Webhook/WebhookEventsList";
import { resetWebhookSecret, resetWebhookSignature } from "../../utils/webhook";
import DataProvider from "../../DataProvider";
import WebhookTriggerChips from "../../components/Webhook/WebhookTriggerChips";

const WebhookShow = (props) => {
  const { location } = props;
  const { organization_id } = parse(location.search);
  const [isSecretVisible, setIsSecretVisible] = useState(false);
  const [webhook, setWebhook] = useState(null);
  const [refreshKey, setRefreshKey] = useState(0);

  // Function to toggle the visibility of the secret
  const toggleSecretVisibility = () => {
    setIsSecretVisible(!isSecretVisible);
  };

  // Function to handle the reset of the webhook secret
  const handleResetSecret = async () => {
    if (window.confirm("Are you sure you want to reset the secret?")) {
      try {
        await resetWebhookSecret(webhook.id);
        alert("Secret reset successfully!");
        fetchWebhookData(); // Re-fetch data after resetting the secret
      } catch (error) {
        alert(`Failed to reset secret: ${error.message}`);
      }
    }
  };

  // Function to handle the reset of the webhook signature
  const handleResetSignature = async () => {
    if (window.confirm("Are you sure you want to reset the signature?")) {
      try {
        await resetWebhookSignature(webhook.id);
        alert("Signature reset successfully!");
        fetchWebhookData(); // Re-fetch data after resetting the signature
      } catch (error) {
        alert(`Failed to reset signature: ${error.message}`);
      }
    }
  };

  // Function to fetch webhook data from the backend
  const fetchWebhookData = async () => {
    try {
      const response = await DataProvider.getOne("webhooks", {
        id: props.id,
      });
      setWebhook(response.data);
    } catch (error) {
      console.error("Failed to fetch webhook data:", error);
    }
  };
  // useEffect to re-fetch webhook data when `isSecretVisible` changes or on component mount
  useEffect(() => {
    fetchWebhookData();
  }, [isSecretVisible, props.id, refreshKey]);

  return (
    <ShowController {...props} key={refreshKey}>
      {() => (
        <Show
          {...props}
          actions={<CustomShowActions overrideOrgID={organization_id} />}
          title="Webhook"
        >
          <SimpleShowLayout>
            {/* Assuming `webhook` is now directly used from state for rendering */}
            <ReferenceField
              source="org_id"
              reference="organizations"
              link="show"
            >
              <TextField source="name" />
            </ReferenceField>
            {webhook && (
              <Labeled label="Alert Types">
                <WebhookTriggerChips record={webhook} />
              </Labeled>
            )}

            <TextField source="destination" />
            <TextField source="delay" />

            <Typography variant="h5">Webhook Secrets</Typography>
            {isSecretVisible && webhook ? (
              <div style={{ display: "flex", flexDirection: "column" }}>
                {/* <Labeled label="signature">
                  <div>{webhook.signature}</div>
                </Labeled> */}
                <Labeled label="Secret">
                  <div>{webhook.secret}</div>
                </Labeled>
              </div>
            ) : null}
            <div style={{ display: "flex" }}>
              <Button
                onClick={toggleSecretVisibility}
                variant="outlined"
                color="primary"
                style={{ margin: "10px" }}
              >
                {isSecretVisible ? "Hide Secrets" : "Show Secrets"}
              </Button>
              <Button
                onClick={handleResetSignature}
                variant="outlined"
                color="primary"
                style={{ margin: "10px" }}
              >
                Reset Signature
              </Button>
              <Button
                onClick={handleResetSecret}
                variant="outlined"
                color="primary"
                style={{ margin: "10px" }}
              >
                Reset Secret
              </Button>
            </div>
            <Typography variant="h5">Webhook Events</Typography>
            <WebhookEventsList
              filter={{ webhook_id: webhook ? webhook.id : null }}
            />
          </SimpleShowLayout>
        </Show>
      )}
    </ShowController>
  );
};

export default WebhookShow;
